declare namespace $ {

	type $mol_keyboard_state__key_bog_gamengine_demo_1 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo['key_map'] >
		,
		ReturnType< $mol_keyboard_state['key'] >
	>
	type $mol_switch__value_bog_gamengine_demo_2 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo['cam_kind'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_gamengine_demo_3 = $mol_type_enforce<
		({ 
			'flat': string,
			'deep': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_5 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo['paused'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $bog_gamengine_draw__scene_bog_gamengine_demo_6 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo['Scene'] >
		,
		ReturnType< $bog_gamengine_draw['scene'] >
	>
	type $bog_gamengine_draw__cam_bog_gamengine_demo_7 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo['cam'] >
		,
		ReturnType< $bog_gamengine_draw['cam'] >
	>
	type $mol_view__sub_bog_gamengine_demo_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_bog_gamengine_demo_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_gamengine_demo_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_gamengine_demo_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_bog_gamengine_demo_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type __bog_gamengine_demo_13 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo['paused'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo['Clock'] >['paused'] >[0]
	>
	type $bog_gamengine_batch__nodes_bog_gamengine_demo_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_batch['nodes'] >
	>
	type $bog_gamengine_scene__clock_bog_gamengine_demo_15 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo['Clock'] >
		,
		ReturnType< $bog_gamengine_scene['clock'] >
	>
	type $bog_gamengine_scene__kids_bog_gamengine_demo_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_scene['kids'] >
	>
	type $bog_gamengine_scene__batches_bog_gamengine_demo_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_scene['batches'] >
	>
	type $bog_gamengine_cam_deep__pos_bog_gamengine_demo_18 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo['cam_deep_pos'] >
		,
		ReturnType< $bog_gamengine_cam_deep['pos'] >
	>
	export class $bog_gamengine_demo extends $mol_book2_catalog {
		key_map( ): Record<string, any>
		Control( ): $mol_keyboard_state
		cam_kind( next?: string ): string
		Cam_switch( ): $mol_switch
		Pause( ): $mol_check_box
		cam( ): $bog_gamengine_cam
		stat( ): ReturnType< ReturnType< $bog_gamengine_demo['Draw'] >['stat'] >
		Draw( ): $bog_gamengine_draw
		Stat( ): $mol_view
		Quad( ): $mol_page
		Flat( ): $bog_gamengine_demo_flat
		Room( ): $bog_gamengine_demo_room
		Boxes( ): $bog_gamengine_demo_boxes
		Jumper( ): $bog_gamengine_demo_jumper
		Shooter( ): $bog_gamengine_demo_shooter
		Legion( ): $bog_gamengine_demo_legion
		Studio( ): $bog_gamengine_studio
		Crumb( ): $bog_gamengine_demo_crumb
		Crumb_studio( ): $bog_gamengine_demo_crumb_studio
		Crumb2( ): $bog_gamengine_demo_crumb2
		paused( next?: ReturnType< ReturnType< $bog_gamengine_demo['Clock'] >['paused'] > ): ReturnType< ReturnType< $bog_gamengine_demo['Clock'] >['paused'] >
		Batch( ): $bog_gamengine_batch
		cam_deep_pos( ): Float32Array
		param( ): string
		placeholders( ): readonly($mol_view)[]
		plugins( ): readonly(any)[]
		spreads( ): ({ 
			'quad': ReturnType< $bog_gamengine_demo['Quad'] >,
			'flat': ReturnType< $bog_gamengine_demo['Flat'] >,
			'room': ReturnType< $bog_gamengine_demo['Room'] >,
			'boxes': ReturnType< $bog_gamengine_demo['Boxes'] >,
			'jumper': ReturnType< $bog_gamengine_demo['Jumper'] >,
			'shooter': ReturnType< $bog_gamengine_demo['Shooter'] >,
			'legion': ReturnType< $bog_gamengine_demo['Legion'] >,
			'studio': ReturnType< $bog_gamengine_demo['Studio'] >,
			'crumb': ReturnType< $bog_gamengine_demo['Crumb'] >,
			'crumb_studio': ReturnType< $bog_gamengine_demo['Crumb_studio'] >,
			'crumb2': ReturnType< $bog_gamengine_demo['Crumb2'] >,
		}) 
		Clock( ): $bog_gamengine_clock
		Scene( ): $bog_gamengine_scene
		Spin( ): $bog_gamengine_demo_spin
		Cam_flat( ): $bog_gamengine_cam_flat
		Cam_deep( ): $bog_gamengine_cam_deep
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map